import React from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { makeStyles } from '@mui/styles';

function SMCModalHeader({
    closeFunction,
    title,
    innerId
}) {
    const classes = useStyles();

    return (
        <div className={classes.root} id={innerId}>
            <span className={classes.title}>{title}</span>
            <span className={classes.closeButton} onClick={closeFunction}><FontAwesomeIcon icon="times"/></span>
        </div>
    );
}

const useStyles = makeStyles({
    root: {
        height: '36px',
        background: '#2e3f58',
        cursor: 'move',
        width: '100%',
        textAlign: 'center'
    },
    title: {
        textTransform: 'uppercase',
        position: 'absolute',
        top: '9px',
        left: '20px',
        fontSize: '13px',
        fontWeight: '400',
        color: '#e8f1ff'
    },
    closeButton: {
        position: 'relative',
        top: '7px',
        right: '2px',
        color: '#e8f1ff',
        opacity: '0.8',
        float: "right",
        paddingRight: '10px',
        cursor: "pointer"
    }
})

SMCModalHeader.propTypes = {
    closeFunction: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
}

export default SMCModalHeader;